import React from 'react'
import Svg from './Svg'
export const SvgTrash = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M3.5 7.5v15c0 .825.675 1.5 1.5 1.5h13.5c.825 0 1.5-.675 1.5-1.5v-15H3.5zM8 21H6.5V10.5H8V21zm3 0H9.5V10.5H11V21zm3 0h-1.5V10.5H14V21zm3 0h-1.5V10.5H17V21zM20.375 3H15.5V1.125C15.5.506 14.994 0 14.375 0h-5.25C8.506 0 8 .506 8 1.125V3H3.125C2.506 3 2 3.506 2 4.125V6h19.5V4.125C21.5 3.506 20.994 3 20.375 3zM14 3H9.5V1.519H14V3z" />
  </Svg>
))
SvgTrash.isIcon = true
export default SvgTrash
